import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import Sidebar from './components/Sidebar';
import MainContent from './components/MainContent';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import StickyBanner from './components/StickyBanner';

export default function Home() {
  return (
    <div className="min-h-screen bg-white text-slate-700">
      <Navbar />
      <HeroSection />
      <FeaturesSection />

      <section className="bg-white py-10 pb-32 md:pb-24 lg:pb-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row md:items-start gap-6 md:gap-8 lg:gap-10">
            <Sidebar />
            <MainContent />
          </div>
        </div>
      </section>

      <CTASection />
      <Footer />
      <StickyBanner />
    </div>
  );
}
